export default __webpack_public_path__ + "static/media/ico_live.fef494ee.svg";